"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    error: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    },
    textError: {
      fontWeight: 300,
      fontSize: "1em"
    }
  };
});

function NotFound() {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.textError
  }, "Ocurri\xF3 un error al cargar el formulario"));
}

var _default = NotFound;
exports.default = _default;